import { useCallback } from 'react';

export function usePickFiles() {
  const pick = useCallback(
    ({
      accept,
      multiple = false,
      onFiles,
    }: {
      accept?: string | string[];
      multiple?: boolean;
      onFiles: (files: File[]) => void;
    }) => {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = multiple;

      if (accept) {
        const acceptString = Array.isArray(accept) ? accept.join(',') : accept;
        input.accept = acceptString;
      }

      input.addEventListener('change', (e) => {
        const target = e.target as HTMLInputElement;
        const files = target.files ? Array.from(target.files) : [];
        onFiles?.(files);
      });

      input.click();
    },
    []
  );
  return { pick };
}
